export default {
  paymentApplyListAdd: {
    billInfo: {
      title: '付款申请单',
      requestCompanyCode: '公司代码',
      companyCodePlaceholder: '请选择公司代码',
      departmentCodePlaceholder: '请选择部门代码',
      requestDepartmentCode: '部门',
      requestDepartmentCodePlaceholder: '请选择部门',
      paymentType: '付款类别',
      paymentTypePlaceholder: '请选择付款类别',
      payee: '收款单位',
      payeePlaceholder: '请选择收款单位',
      bank: '开户银行',
      bankPlaceholder: '请选择开户银行',
      bankAccount: '银行账号',
      bankAccountPlaceholder: '请选择银行账号',
      bankUnionNumber: '联行号',
      bankBranch: '开户分行',
      paymentMethod: '付款方式',
      paymentMethodPlaceholder: '请选择付款方式',
      requestPerson: '申请人',
      requestAmount: '申请金额原币',
      requestAccountedAmount: '申请金额本位币',
      currencyName: '币种',
      exchangeType: '汇率类型',
      exchangeRate: '汇率',
      exchangeRatePlaceholder: '请选择汇率',
      currencyPlaceholder: '请选择币种',
      exchangeRateDate: '汇率日期',
      requestStatus: '单据状态',
      paidAmount: '已付款金额原币',
      unpaidAmount: '未付款金额原币',
      paymentApplyNumber: '申请单号',
      requestDate: '申请日期',
      isVirtual: '虚拟标识',
      paidAccountedAmount: '已付款金额本位币',
      unpaidAccountedAmount: '未付款金额本位币',
      availableCreditAmount: '可用信用额度',
      summary: '摘要',
      remarksPlaceholder: '请填写摘要',
      closeReason: '关闭原因',
      closeReasonPlaceholder: '请填写关闭原因',
    },
    accountingInfo: {
      title: '财务信息',
      postStatus: '入账状态',
      postDate: '入账日期',
      voucherCode: '凭证编号',
      reversePostDate: '冲销入账日期',
      reverseVoucherCode: '冲销凭证编号',
      payableAccount: '应付科目',
    },
    invoiceLine: {
      title: '行信息',
      btns: {
        delete: '删除行',
        add: '新增行',
      },
      table: {
        payableInvoiceDetailNo: '行号',
        requestAmount: '申请金额原币',
        expenseType: '款项内容',
        purchaseOrderNo: '采购合同号',
        puchaseOrderDetailNo: '采购合同行项目号',
        productName: '商品/服务描述',
        invoiceCode: '发票编号',
        salesOrderNo: '销售合同号',
        salesOrderDetailNo: '销售提单号',
        currencyName: '币种',
        businessPersonName: '业务员',
        mark: '备注',
        paidAmount: '已付款金额',
        unpaidAmount: '未付款金额',
        exchangeRate: '汇率',
        requestAccountedAmount: '申请金额本位币',
        paidAccountedAmount: '已付款金额本位币',
        unpaidAccountedAmount: '未付款金额本位币',
        orderUnpaidAmount: '合同未付款金额',
        batchSettleNo: '结算批次号',
        supplychain: '供应链主体',
        orderNo: '业务订单号',
        instructionNo: '发货指令编号',
        instructionDetailNo: '发货指令行号',
        actualPayeeAccount: '实际收款人账号',
        actualPayee: '实际收款人',
        projectInitiationNo: '项目编号',
        settlementPaidAmount: '结算单已付金额',
        settlementUnpaidAmount: '结算单未付金额',
        actualBankName: '开户银行',
        actualBankUnionNumber: '联行号',
        actualBankBranch: '开户分行',
      },
      rules: {
        input: '请填写',
        select: '请选择',
      },
    },
    btns: {
      save: '保存',
      approval: '提交审批',
      pay: '提交付款',
      close: '申请关闭',
      payment: '生成付款单',
      approve: '批准',
      doWithdraw: '撤回',
    },
    prompt: {
      writeOffEntryDate: '请选择冲销日期',
      accountEntryDate: '请选择入账日期',
    },
    warnInfo: {
      infoInfo: '请填写发票信息',
    },
  },
};
